module.exports = __webpack_public_path__ + "static/media/Pangram-Bold.cda477ef.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Pangram-Bold.otf
// module id = 698
// module chunks = 0